import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { useMutation, useQueryClient } from 'react-query';

export interface ToggleVehicleDetectionVariables {
  cameraId: string;
  isVehicleProcessingEnabled: boolean;
  tenantId?: string;
}

export function useToggleVehicleDetection(
  onSuccess?: () => void,
  onError?: (error: Error) => void
) {
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();

  return useMutation<null, Error, ToggleVehicleDetectionVariables>(
    async ({ cameraId, isVehicleProcessingEnabled, tenantId }) => {
      const finalUrl = `/v2/orm/camera/${cameraId}/toggleVehicle`;
      const request = new Request(finalUrl, {
        method: 'PATCH',
        body: JSON.stringify({ isVehicleProcessingEnabled, tenantId }),
      });
      return httpClient<null>(request);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('cameras');
        if (onSuccess) onSuccess();
      },
      onError,
    }
  );
}

export default useToggleVehicleDetection;
